import { Controller } from "@hotwired/stimulus"

const POLL_INTERVAL_MS = 2500
// Un legajo grande (ej. plantilla "Subsidio de salud") puede tardar varios minutos.
const MAX_WAIT_MS = 15 * 60 * 1000 // 15 minutos

// Connects to data-controller="reporte-estado"

export default class extends Controller {
  static targets = ["procesando", "error", "errorMessage", "listo", "downloadLink", "demora"]
  static values = {
    estadoUrl: String,
    empezoEnError: Boolean,
    empezoListo: Boolean,
    readyBehavior: { type: String, default: "navigate" },
    downloadUrl: String
  }

  connect() {
    if (this.empezoEnErrorValue) return

    if (this.empezoListoValue) {
      this.triggerDownload(this.downloadUrlValue)
      return
    }

    this.startedAt = Date.now()
    this.poll()
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  async poll() {
    try {
      const response = await fetch(this.estadoUrlValue, { headers: { "Accept": "application/json" } })

      if (response.ok) {
        const data = await response.json()

        if (data.status === "ready" && data.url) {
          if (this.readyBehaviorValue === "download") {
            this.showListo(data.url)
          } else {
            window.location.replace(data.url)
          }
          return
        }

        if (data.status === "error") {
          this.showError(data.message)
          return
        }
      }
    } catch (e) {
      // Hipo de red puntual: seguimos reintentando hasta el límite de espera.
    }

    if (Date.now() - this.startedAt > MAX_WAIT_MS) {
      this.showDemora()
      return
    }

    this.timeout = setTimeout(() => this.poll(), POLL_INTERVAL_MS)
  }

  showListo(url) {
    if (this.hasProcesandoTarget) this.procesandoTarget.classList.add("d-none")
    if (this.hasListoTarget) this.listoTarget.classList.remove("d-none")
    if (this.hasDownloadLinkTarget) this.downloadLinkTarget.href = url

    this.triggerDownload(url)
  }

  // Demorado no es error: el trabajo sigue corriendo, así que no se ofrece "Reintentar"
  // (encolaría otra generación igual en paralelo).
  showDemora() {
    if (!this.hasDemoraTarget) {
      this.showError("Esto está tardando más de lo esperado. Podés cerrar esta pestaña con confianza: en unos minutos volvé a pedir el mismo reporte y va a aparecer al instante.")
      return
    }

    if (this.hasProcesandoTarget) this.procesandoTarget.classList.add("d-none")
    this.demoraTarget.classList.remove("d-none")
  }

  showError(message) {
    if (this.hasProcesandoTarget) this.procesandoTarget.classList.add("d-none")
    if (this.hasErrorTarget) this.errorTarget.classList.remove("d-none")
    if (this.hasErrorMessageTarget && message) this.errorMessageTarget.textContent = message
  }

  triggerDownload(url) {
    if (!url) return

    window.location.href = url
  }

  cerrar(event) {
    event.preventDefault()
    window.close()
  }
}
